define(
    [
        'text!./templates/basler-summary-infobox.html',
        'text!./templates/basler-edit-infobox.html',
        'underscore',
    ],
    (templateStr, editPopupTemplate, _) => ['BaslerCommonService', 'ModalService', 'qnb.LoadSaveService', 'DefaultErrorHandlerService', '$filter', 'StateUtils', '$state', 'ViewModelService', 'MFPCoverageService', 'ContextService',
        function (BaslerCommonService, ModalService, LoadSaveService, DefaultErrorHandlerService, $filter, StateUtils, $state, ViewModelService, MFPCoverageService, ContextService) {
            return {
                restrict: 'A',
                scope: {
                    /*
                     * This tricky directive allows following combination of parameters:
                     * periodStart + periodEnd
                     * paymentMethod + submissionView (actually, due to complexity of the page, payment method will be retrieved from multiple places)
                     * premium
                     *
                     * class parameter it's independent
                     */
                    paymentMethod: '=',
                    periodStart: '=',
                    periodEnd: '=',
                    premium: '=',
                    directiveClass: '@',
                    submissionView: '=',
                    monthlyPremium: '=?',
                    originalTotal: '=?',
                    promotionData: '=?',
                    promotionSum: '=?',
                },
                template: templateStr,

                controller: ['$scope', function ($scope) {

                    $scope.formatLocalDate = formatLocalDate;
                    $scope.displayEditButton = displayEditButton;
                    $scope.showPopup = showPopup;
                    $scope.displayMoveToFirstPageButton = displayMoveToFirstPageButton;
                    $scope.selectStep = selectStep;
                    $scope.setModel = setModel;
                    $scope.showDiscountMessage = showDiscountMessage;
                    $scope.hasPromotion = hasPromotion;
                    $scope.showMonthly = () => ContextService.isPartnerLeasingProduct();
                    $scope.getHeadingTranslation = () => (ContextService.isPartnerLeasingProduct() ? 'quoteandbind.directives.templates.basler-show-policy-info.monthlyPremium' : 'quoteandbind.directives.templates.basler-summary-infobox.premium');
                    $scope.displayPaymentMethod = displayPaymentMethod;
                    // Checking that a proper combination of parameters have been provided
                    checkPreconditions();

                    function formatLocalDate(localDate) {
                        return BaslerCommonService.formatLocalDate(localDate);
                    }

                    function hasPromotion(promotionData) {
                        if (!promotionData || $scope.paymentMethod) {
                            return false;
                        }
                        return MFPCoverageService.hasPromotionsInAnyGroup(promotionData);
                    }

                    /*
                     * Displaying edit button to allow changing payment method
                     */
                    function displayEditButton() {
                        return !!$scope.paymentMethod && !$scope.showMonthly();
                    }

                    /*
                     * Displaying payment method
                     */
                    function displayPaymentMethod() {
                        return $scope.showMonthly() && !ContextService.isLeasePlan() ?
                            $filter('translate')('typekey.PaymentMethod_Ext.monthly') : $scope.paymentMethod.value.name;
                    }

                    /*
                     * Displaying edit button to allow navigating back to mfpRiskRelevantPage
                     */
                    function displayMoveToFirstPageButton() {
                        return !!$scope.periodStart && !!$scope.periodEnd;
                    }

                    /*
                     * Navigating to the target page with the data for the step (that means, last updated payment method BUT NOTHING OF WHAT THE USER HAS ENTERED
                     * INTO THE PAGE
                     * This means, i. e. that any license plate introduced won't be added to the submission that arrives to the target page.
                     */
                    function selectStep(stateName) {
                        const { flowModel } = StateUtils.activeDataForState(true);
                        const { steps } = flowModel;
                        const mfpRiskDataStep = _.findWhere(steps, {name: stateName});

                        flowModel.jumpToStep(mfpRiskDataStep, $scope.$parent.submissionSnapshot, undefined, true);
                    }

                    /*
                    * This method updates the model after changing paymentMethod
                    * It's a pretty weird method due to we have to update model without interfere with whatever the user is introducing in
                    * other fields of the page (i. e., maybe the user is in the middle of introducing a license plate)
                    * The idea is to update the snapshot of the original submissionView (that means, if the user change from annual to semestral, next time the data for this step
                    * shall be semestral) without taking other data in the page into consideration
                    * Also updating "premium" variable in the parent scope to allow the new premium to be reflected on the page
                     */
                    function setModel(newSubmissionObject) {
                        const snapshot = ViewModelService.create(newSubmissionObject, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO');
                        $scope.submissionView.draftData.paymentMethod.value = newSubmissionObject.draftData.paymentMethod;

                        const parentSelectedQuote = _.findWhere(snapshot.quoteData.offeredQuotes.value, {isSelected: true});
                        const selectedQuote = _.findWhere(newSubmissionObject.quoteData.offeredQuotes, {isSelected: true});
                        parentSelectedQuote.total.amount = selectedQuote.total.amount;
                        $scope.$parent.premiumAmount.amount = selectedQuote.total.amount;
                        $scope.$parent.originalTotal.amount = selectedQuote.originalTotal.amount;
                        $scope.$parent.getPromotionDataFromSelectedQuote(selectedQuote);
                    }


                    /*
                     * This function checks if additional information for Employee should be displayed
                     */
                    function showDiscountMessage() {
                        return !!$scope.premium && $scope.$parent.submission.draftData.employeeMode;
                    }

                    /*
                    * This function execute the popup that allows change payment method
                     */
                    function showPopup() {

                        const initialPaymentMethod = angular.copy($scope.submissionView.draftData.paymentMethod.value.code);

                        // Diego Cabero: This complex implementation is because we have to update ONLY payment method by going to the backend.
                        // That means we cannot simply use $scope.submissionView.value, as it could contain wrong data the user has introduce in
                        // any other field of Summary page (i.e., a wrong license plate)
                        // That we're going to do is take a snapshot of gotten SubmissionView when navigated into SummaryPage plus the new payment method

                        const snapShot = StateUtils.activeDataForState(true).flowModel.snapshot;
                        snapShot.draftData.paymentMethod.value = $scope.submissionView.draftData.paymentMethod.value;

                        const data = {
                            submissionView: snapShot,
                            initialPaymentMethod: initialPaymentMethod,
                        };

                        const functions = {

                            /*
                             * This method for the scope of the popup controls the submit of the popup (clicking ok, basically).
                             * It will update payment method in the backend and update the model for the step and for the parent scope
                             */
                            submitForm: function (modalScope, form) {
                                form.submitted = true;
                                if (!form.valid) {
                                    return;
                                }

                                if (initialPaymentMethod === modalScope.submissionView.draftData.paymentMethod.value.code) {
                                    modalScope.$dismiss();
                                } else {
                                    const saveAndRequotePromise = LoadSaveService.editQuotedSubmissionAndRequote('quoteandbind', modalScope.submissionView.value);
                                    ModalService.showProgressDialog('quoteandbind.directives.templates.basler-edit-infobox.updatingYourSubmission', saveAndRequotePromise);

                                    modalScope.$dismiss();

                                    saveAndRequotePromise.then((quotedSubmission) => {
                                        if (!(quotedSubmission.uWIssues)) {
                                            $scope.setModel(quotedSubmission);
                                        }
                                    }, (error) => {
                                        modalScope.submissionView.draftData.paymentMethod.value = _.findWhere(modalScope.submissionView.draftData.paymentMethod.aspects.availableValues, {code: initialPaymentMethod});

                                        if (!DefaultErrorHandlerService.getErrorHandlerForError(error[0])()) {
                                            ModalService.showError(
                                                $filter('translate')('quoteandbind.directives.templates.basler-edit-infobox.ServerErrorTitle'),
                                                $filter('translate')('quoteandbind.directives.templates.basler-edit-infobox.ServerErrorDescription')
                                            );
                                        }
                                    });
                                }
                            },

                            /*
                             * This controls if the ugly green message will be displayed based on the initial value of payment method stored in the snapshot.
                             */
                            showInfoMessage: function (modalScope) {
                                return (initialPaymentMethod !== modalScope.submissionView.draftData.paymentMethod.value.code);
                            },
                        };

                        ModalService.showSimpleDialog(editPopupTemplate, data, functions);
                    }

                    // Diego Cabero: Precondition checks. Only premium OR periodStart + PeriodEnd OR paymentMethod shall be defined
                    function checkPreconditions() {

                        if ($scope.displayEditButton() && !$scope.submissionView) {
                            throw new Error('BaslerSummaryInfobox: submissionView required if edit button is enabled.');
                        }

                        if ((!!$scope.periodStart && !$scope.periodEnd) || (!$scope.periodStart && !!$scope.periodEnd)) {
                            throw new Error('BaslerSummaryInfobox: periodStart AND periodEnd shall be informed');
                        }

                        if ((!!$scope.premium) && (!!$scope.periodStart || !!$scope.periodEnd || !!$scope.paymentMethod)) { // NOSONAR
                            throw new Error('BaslerSummaryInfobox: Ambiguous call: if premium is informed, neither periodStart, periodEnd nor paymentMethod are expected to be defined');
                        }

                        if ((!!$scope.periodStart && !!$scope.periodEnd) && (!!$scope.premium || !!$scope.paymentMethod)) { // NOSONAR
                            throw new Error('BaslerSummaryInfobox: Ambiguous call: if periodStart & periodEnd is informed, neither premium nor paymentMethod are expected to be defined');
                        }

                        if ((!!$scope.paymentMethod) && (!!$scope.periodStart || !!$scope.periodEnd || !!$scope.premium)) { // NOSONAR
                            throw new Error('BaslerSummaryInfobox: Ambiguous call: if paymentMethod is informed, neither periodStart, periodEnd, premium are expected to be defined');
                        }
                    }
                }],
            };
        },
    ]
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerSummaryInfobox.js